import classNames from 'classnames'
import { Fragment, React, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { BASE_MEDIA_QUERY } from '../../static/config'
import CheckResize from './CheckResize'
import Footer from './Footer'
import Sidenav from './Sidenav'
import Topbar from './Topbar'

const Layout = (props) => {
  const { isLoggedIn } = useSelector((state) => state.auth)
  const { sidenavOpened } = useSelector(state => state.ui)

  const layoutClass = classNames('layout', {
    'layout-main': !isLoggedIn,
    'layout-main-auth': isLoggedIn,
    layout_opened: isLoggedIn && sidenavOpened && BASE_MEDIA_QUERY.matches,
    layout_closed: !sidenavOpened
  })

  useEffect(() => {
    if (sidenavOpened && !BASE_MEDIA_QUERY.matches) {
      document.body.style = 'overflow:hidden'
    } else {
      document.body.style = 'overflow:auto'
    }
  }, [sidenavOpened, BASE_MEDIA_QUERY.matches])

  return (
    <Fragment>
      <CheckResize />
      <div className="layout-wrapper">
        {isLoggedIn && <Sidenav />}
        <main className={layoutClass}>
          {isLoggedIn && <Topbar />}
          {<div className="content">
            {props.children}
            {isLoggedIn && <Footer />}
          </div>}
        </main>
      </div>
    </Fragment>
  )
}

export default Layout
